/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Display_Form_LabelInputs */



/**
* | output |
* | --- |
* | "Display Settings" |
*
* @param {Options_Display_Form_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_display_form_label = /** @type {((inputs?: Options_Display_Form_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Display_Form_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Paramètres d'affichage")
	if (locale === "de") return /** @type {LocalizedString} */ ("Anzeigeeinstellungen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impostazioni di visualizzazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Настройки дисплея")
	if (locale === "es") return /** @type {LocalizedString} */ ("Configuración de pantalla")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("显示设置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("表示設定")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रदर्शन सेटिंग्स")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Configurações de exibição")
	return /** @type {LocalizedString} */ ("Display Settings")
});